
import { Vue } from "vue-class-component";
export default class TicketSubmission extends Vue {}
